/**
 * Converts a value in base currency units to cents
 * @param value - Value in base currency units (e.g., EUR, GBP)
 * @returns Value in cents
 */
export const convertToCents = (value: number): number => {
  return Math.round(value * 100);
};

/**
 * Converts a value in cents to base currency units
 * @param cents - Value in cents
 * @returns Value in base currency units (e.g., EUR, GBP)
 */
export const convertFromCents = (cents: number): number => {
  return cents / 100;
};
